import createReducer from 'redux-request-state/reducers/createReducer';
import actionsToArtifacts from 'automation-ui-canvas/actions/utils/actionsToArtifacts';
const mapActionsToArtifacts = action => {
  const {
    type
  } = action;
  return actionsToArtifacts[type] ? actionsToArtifacts[type](action) : null;
};
export default createReducer(mapActionsToArtifacts);